import React from "react";
import { GridToolbarContainer } from "@mui/x-data-grid";
import { IconButton, Tooltip } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import SaveIcon from "@mui/icons-material/Save";
import DeleteIcon from "@mui/icons-material/Delete";

export interface SkuBaseForecastToolbarProps {
    isLocked: boolean;
    hasEdits: boolean;
    selectedRowId: string | number | null;
    onCreate: () => void;
    onSave: () => void;
    onDelete: (rowId: string | number) => void;
}

const SkuBaseForecastToolbar: React.FC<SkuBaseForecastToolbarProps> = ({
    isLocked,
    hasEdits,
    selectedRowId,
    onCreate,
    onSave,
    onDelete
}) => {
    const handleCreateClick = () => {
        if (!isLocked) {
            onCreate();
        }
    };

    const handleSaveClick = () => {
        if (hasEdits) {
            onSave();
        }
    };

    const handleDeleteClick = () => {
        if (selectedRowId !== null && !isLocked) {
            onDelete(selectedRowId);
        }
    };

    return (
        <GridToolbarContainer sx={{ justifyContent: "flex-end" }}>
            <Tooltip title="Create">
                <span>
                    <IconButton
                        aria-label="createSkuBaseForecast"
                        onClick={handleCreateClick}
                        disabled={isLocked}
                    >
                        <AddIcon />
                    </IconButton>
                </span>
            </Tooltip>
            <Tooltip title="Save">
                <span>
                    <IconButton
                        aria-label="save"
                        onClick={handleSaveClick}
                        disabled={!hasEdits}
                    >
                        <SaveIcon />
                    </IconButton>
                </span>
            </Tooltip>
            <Tooltip title="Delete">
                <span>
                    <IconButton
                        aria-label="delete"
                        onClick={handleDeleteClick}
                        disabled={selectedRowId === null || isLocked}
                    >
                        <DeleteIcon />
                    </IconButton>
                </span>
            </Tooltip>
        </GridToolbarContainer>
    );
};

export default SkuBaseForecastToolbar;
